import { useCallback } from 'react';
import type { FunctionComponent } from 'react';
import Slider from 'rc-slider';
import styled from 'styled-components';
import Image from '../atoms/Image';
import Assets from '../../assets/Assets';
import 'rc-slider/assets/index.css';
import { SizeFromProps } from '../../utils/styledcomponents';
import type { SizeProps } from '../../utils/styledcomponents';

const HANDLE_SIZE = '5vmin';

const Control = styled.div`
	color: ${(props) => props.theme.colors.lightBlue};
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
`;

const StyledSlider = styled(Slider)`
	margin-left: ${HANDLE_SIZE};
	margin-right: ${HANDLE_SIZE};
	.rc-slider-rail {
		background-color: ${(props) => props.theme.colors.white};
	}
	.rc-slider-track {
		background-color: ${(props) => props.theme.colors.lightBlue};
	}
	.rc-slider-handle {
		box-shadow: 0.8vmin 0.8vmin 0 0 ${(props) => props.theme.colors.shadow};
		width: ${HANDLE_SIZE};
		height: ${HANDLE_SIZE};
		margin-top: calc(-1 * ((${HANDLE_SIZE} - 2px) / 2));
		background-color: ${(props) => props.theme.colors.lightBlue};
		border: none;
	}
	.rc-slider-handle:focus {
		box-shadow: 0.8vmin 0.8vmin 0 0 ${(props) => props.theme.colors.shadow};
	}
`;

interface Props {
	className?: string;
	enabled: boolean;
	onSoundEnabled: (enabled: boolean) => void;
	volume: number;
	onVolumeChanged: (volume: number) => void;
}

const VolumeControl: FunctionComponent<Props> = (props: Props) => {
	const { enabled, volume, onSoundEnabled, onVolumeChanged, className } = props;

	const handleChange = useCallback(
		(newVolume: number): void => {
			const newEnabled = newVolume > 0;
			if (newEnabled !== enabled) {
				onSoundEnabled(newEnabled);
			}
			if (newVolume !== volume) {
				onVolumeChanged(newVolume / 100.0);
			}
		},
		[enabled, volume, onSoundEnabled, onVolumeChanged]
	);

	const currentVolume = enabled ? volume * 100 : 0;

	return (
		<Control className={className}>
			<Image src={Assets.images.volumeLow} width="16vmin" height="16vmin" />
			<StyledSlider
				min={0}
				max={100}
				step={10}
				value={currentVolume}
				onChange={handleChange}
			/>
			<Image src={Assets.images.volumeHigh} width="16vmin" height="16vmin" />
		</Control>
	);
};

export default styled(VolumeControl)<SizeProps>(SizeFromProps);
